module.exports = __webpack_public_path__ + "img/quickmoney.27c73a28.png";